import { useContext } from "react";
import { ModalContext } from "context/ModalContext";
import { Button, Input, Pagination } from 'antd';
import AddDmvic from 'components/widgets/modals/AddDmvic';
import Dmvic_Credential from "components/widgets/forms/setup/Dmvic_Credential";
import { list_dmvics } from "services/apiSrv";
import { useQuery } from "react-query";

function Dmvic(props) {
          const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
			const {
			data: dmvics,
			isLoading: isDmvicLoading,
			isError: isDmvicError,
			error: dmvicError,
		} = useQuery({
			queryKey: ['dmvics'],
			queryFn: list_dmvics,
			// Optional: Configure retry, stale time, etc.
			retry: 2,
			staleTime: 5 * 60 * 1000, // 5 minutes
		});
		
    return (
        <div >
       

            <AddDmvic show={modalShow} onHide={modalClose} /> 
            <div>
				
           <Dmvic_Credential />
		   <div style={
					{ borderRadius: "12PX", background: "#ffffff",   padding:"2rem"}
				}>
            <Button className="text-white btn-blue rounded float-right mb-3" onClick={() => setModalShow(true)}>
                Add Underwriter
            </Button>
                Underwriters
               <div className="mg-b-20">
					<div className="card-body pd-0 collapse show" id="customerDetails">
						<div className="table-responsive">
							<table className="table table-hover mg-0">
								<thead className="tx-dark tx-uppercase tx-12 tx-bold">
									<tr className="bg-light">
										<th className="">Name</th>
										<th className="">Member ID</th>
									</tr>
								</thead>
								<tbody>
								        {dmvics?.data?._value && dmvics?.data?._value.length > 0 ? (
											dmvics.data._value.map((dmvic, index) => (
											<tr key={index}>
												<td>{dmvic?.name || '-'}</td>
												<td>{dmvic.memberId}</td>
											</tr>
											))
										) : (
											<tr>
											<td colSpan="2">No data available</td>
											</tr>
										)}
								</tbody> 
							</table>
						</div>
					</div>
				</div>
		   </div>


            </div>
        </div>
    );
}

export default Dmvic;